import { composeIO } from 'react-compose-io'
import { tabStatusIO } from './TabStatus.IO'
import TabStatusView from './TabStatus.View'

export const TabStatus = composeIO(TabStatusView, tabStatusIO)
